import { printFontPx, qrWidthMm, usableWidthMm } from '@optiflow/shared';
import { PRINT_PAPER, type PrintTemplate } from '@optiflow/types';

/** How a template lays a document out, derived in one place for the print page and the settings preview alike. */
export interface PrintLayout {
  kind: 'thermal' | 'sheet';
  /** Paper width less side margins: the only width the document is ever given. */
  widthMm: number;
  fontPx: number;
  qrMm: number;
}

export function printLayout(template: PrintTemplate): PrintLayout {
  return {
    kind: PRINT_PAPER[template.paperSize].kind,
    widthMm: usableWidthMm(template),
    fontPx: printFontPx(template),
    qrMm: qrWidthMm(template),
  };
}

/**
 * The page rule the printer obeys: the template's margins, and the sheet size for A4 and A5.
 *
 * A thermal roll gets no size — drivers honour a custom roll size unevenly, so the document is made
 * exactly as wide as the roll less its margins instead, which prints correctly either way.
 */
export function printPageRule(template: PrintTemplate): string {
  const margins = `${template.marginTopMm}mm ${template.marginRightMm}mm ${template.marginBottomMm}mm ${template.marginLeftMm}mm`;
  return PRINT_PAPER[template.paperSize].kind === 'sheet'
    ? `@page { size: ${template.paperSize}; margin: ${margins}; }`
    : `@page { margin: ${margins}; }`;
}
